<template>
  <div class="container" ref="wrapper">
    <van-sticky>
      <van-nav-bar
        title="我参加的考试"
        left-arrow
        @click-left="$router.back()"
      />
    </van-sticky>
    <van-search
      v-model="page.filterData.examTitle"
      @search="onSearch"
      placeholder="请输入搜索关键词"
    />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="upLoading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <van-cell-group>
          <!-- art_id有可能是大数字 超过一定长度会转成 BigNumber  要toString一下 -->
          <van-cell
            v-for="item in articles"
            :key="item.id.toString()"
            @click="toArticleDetail(item.id.toString())"
          >
            <van-col span="24" align="bottom">
              <div
                style="display: table-cell; vertical-align: middle"
                class="zntitle van-multi-ellipsis--l3"
              >
                <h3 style="display: inline-block">{{ item.examTitle }}</h3>
              </div>

              <div style="float: left">{{ item.creationTime }}</div>

              <div style="float: right; margin-right: 5px">
                <van-tag v-if="item.isPass" round size="large" color="rgb(0 176 80)">
                  考试通过
                </van-tag>
                <van-tag v-if="item.isPass==undefined" round size="large" color="#ffc000">
                  待阅卷 
                </van-tag>
                <van-tag v-if="item.isPass==false" round size="large" color="#ff0000">
                  未通过
                </van-tag>
              </div>
              <div v-if="item.score && item.totalScore" style="float: right;margin-right: 10px"><b>{{item.score}}</b>/{{item.totalScore}}</div>
            </van-col>
          </van-cell>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
  
  <script>
import { ExamAnswerList } from "@/api/exam";
//const key = "zn-history";
export default {
  name: "answerList",
  data() {
    return {
      scroll: 0,
      refreshing: false,
      keyword: "",
      upLoading: false,
      finished: false,
      articles: [],
      page: {
        current: 1,
        pageSize: 10,
        sorterType: 0,
        filterData: {
          examTitle: "",
        },
      },
    };
  },
  components: {},
  activated() {
    //  window.scrollTo(0, this.scroll);
    //  alert( this.$refs.wrapper.scrollTop);
    try {
      this.$refs.wrapper.scrollTop = this.scroll;
    } catch (error) {
      console.log(error);
    }
  },
  created() {
    this.onSearch();
  },
  mounted() {},

  methods: {
    onRefresh() {
      this.onSearch();
      this.refreshing = false;
    },

    onSearch() {
      this.finished = false;
      this.articles = [];
      this.page.current = 1;
      this.page.pageSize = 10;
      this.onLoad();
    },
    toArticleDetail(id) {
      let wrapperScrollTop = this.$refs.wrapper.scrollTop;
      //存储 scrollTop 的值
      this.scroll = wrapperScrollTop;

      this.$router.push({
        path: "/exam/answerDetail",
        query: { para: id },
      });
    },
    async onLoad() {
      this.upLoading = true;
      let aresult = await ExamAnswerList({ ...this.page }); //({ ...this.page })
      this.articles.push(...aresult.data.data);
      this.upLoading = false;
      if (this.page.current * this.page.pageSize < aresult.data.total) {
        this.page.current++;
      } else {
        this.finished = true;
      }
    },
  },
};
</script>
  
  <style lang="less" scoped>
.w100 {
  /deep/ img {
    width: 100%;
    max-height: 80px;
  }
}
.zntitle {
  height: 80px;
}
.container {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
}
.detail {
  padding: 46px 10px 44px;
  .title {
    font-size: 18px;
    line-height: 2;
  }
  .zan {
    text-align: center;
    padding: 10px 0;
    .active {
      border-color: red;
      color: red;
    }
  }
  .author {
    padding: 10px 0;
    display: flex;
    position: sticky;
    background-color: #fff;
    top: 46px;
    z-index: 2;
    .text {
      flex: 1;
      padding-left: 10px;
      line-height: 1.5;
      .name {
        font-size: 14px;
        margin: 0;
      }
      .time {
        margin: 0;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .content {
    padding: 20px 0;
    overflow: hidden;
    white-space: pre-wrap;
    word-break: break-all;
    /deep/ img {
      max-width: 100%;
      background: #f9f9f9;
    }
    /deep/ code {
      white-space: pre-wrap;
    }
  }
}
</style>
  